import { adminService } from '@/api/services';

import type { IApiSuccessMessageResponse, UnwrapData } from '../../types';

import type {
  ISchoolDataPatchRequest,
  ISchoolDataPostRequest,
  ISchoolDataResponse,
  ISchoolsDataResponse,
} from './types';

export const schoolsService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить данные по школам
     */
    getSchoolsData: builder.query<UnwrapData<ISchoolsDataResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/schools',
      }),
      providesTags: [{ type: 'Schools', id: 'LIST' }],
      transformResponse: (response: ISchoolsDataResponse): UnwrapData<ISchoolsDataResponse> => response.data,
    }),
    /**
     * Получить данные по конкретной школе
     */
    getSchoolData: builder.query<UnwrapData<ISchoolDataResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/schools/${id}`,
      }),
      providesTags: (_result, _error, { id: schoolId }) => [{ type: 'SchoolInfo', id: schoolId }],
      transformResponse: (response: ISchoolDataResponse): UnwrapData<ISchoolDataResponse> => response.data,
    }),
    /**
     * Изменить данные по конкретной школе
     */
    updateSchoolData: builder.mutation<IApiSuccessMessageResponse, ISchoolDataPatchRequest>({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/schools/${id}`,
        body: {
          id,
          data,
        },
      }),
      invalidatesTags: (_result, _error, { id: schoolId }) => [
        { type: 'SchoolInfo', id: schoolId },
        { type: 'Schools', id: 'LIST' },
      ],
    }),
    /**
     * Создать школу
     */
    createSchool: builder.mutation<UnwrapData<ISchoolDataResponse>, ISchoolDataPostRequest>({
      query: ({ data }) => ({
        method: 'POST',
        url: '/schools',
        body: {
          data,
        },
      }),
      invalidatesTags: [{ type: 'Schools', id: 'LIST' }],
    }),
  }),
});

export const { useGetSchoolsDataQuery, useGetSchoolDataQuery, useUpdateSchoolDataMutation, useCreateSchoolMutation } =
  schoolsService;
